import script from "./OrderEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderEdit.vue?vue&type=script&setup=true&lang=ts"

import "./OrderEdit.vue?vue&type=style&index=0&id=3242fccc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3242fccc"]])

export default __exports__